/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleCommitmentShare extends models.BillingRuleBenefitDistributionBase {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleCommitmentShare");
    }

    getFixupPrototypeFunction() { return BillingRuleCommitmentShare.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleCommitmentShare>): BillingRuleCommitmentShare {
        let obj = Object.assign(new BillingRuleCommitmentShare(), model);
        BillingRuleCommitmentShare.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleCommitmentShare>): BillingRuleCommitmentShare {
        if (!model) return null;
        return BillingRuleCommitmentShare.newInstance(<BillingRuleCommitmentShare> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleCommitmentShare) {
        if (!obj) return;

        models.BillingRuleCommitmentShare.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleCommitmentShare): boolean {
        if (models.BillingRuleBenefitDistributionBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleCommitmentShare.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.targets) {
            for (let val of this.targets) {
                models.ShareTarget.fixupPrototype(val);
            }
        }
    }

    targets: Array<models.ShareTarget>;

}
